<qaroni-animation [src]="src" [height]="height()" />
